export default __webpack_public_path__ + "static/media/event_lobby_image@2x.a2305e2d.jpg";